import { render } from "./template.vue?vue&type=template&id=769de2d5&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=769de2d5&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769de2d5"]])

export default __exports__